export default function colorizeDatum(datum, previousDatum, decorations) {
  if (!datum) return datum
  const { color, isPrevious, previousColor } = decorations
  return {
    ...datum,
    color: isPrevious ? previousColor : color,
  }
}
